var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"rich-content",domProps:{"innerHTML":_vm._s(_vm.processedHtml)},on:{"click":_vm.handleLinkClick}}),(_vm.isWeChat)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.openTagHtml)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }